import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import modalStory from "@irati/utils/modalStory"

import Default from "./Default"
import {DefaultModal} from "./styled/Popup"

const DEFAULT = "DEFAULT"

const modals = [DEFAULT]

class Popup extends PureComponent {
  static propTypes = {
    onHide: PropTypes.func,
    deal: PropTypes.object.isRequired,
    locationsData: PropTypes.array.isRequired,
    selectedLocation: PropTypes.object
  }

  static defaultProps = {
    onHide: () => {},
    selectedLocation: null
  }

  constructor(props) {
    super(props)
    this.state = {
      show: modalStory(modals, null)
    }
  }

  show = (modalToShow = DEFAULT) => {
    this.setState(({show}) => ({
      show: modalStory(modals, modalToShow, show)
    }))
  }

  hide = () => {
    this.setState({
      show: modalStory(modals, null)
    })
    this.props.onHide()
  }

  render() {
    const {deal, locationsData, selectedLocation} = this.props
    const {show} = this.state

    return (
      <DefaultModal
        className="modal-slide-up modal-full-screen"
        show={show[DEFAULT]}
        onHide={this.hide}>
        <Default deal={deal} locationsData={locationsData} selectedLocation={selectedLocation} />
      </DefaultModal>
    )
  }
}

export default Popup
